import { useCallback, useEffect, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import MarkdownPreview from '@uiw/react-markdown-preview';

import Navigation from '../navigation/Navigation';

import { getChatMessages, unbookmarkMessage } from '../../utils/api';

import './Bookmarks.css';

function Bookmarks({ handleError, handleFeedback }) {
  const [bookmarks, setBookmarks] = useState([]);
  const [filterActive, setFilterActive] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const getBookmarks = useCallback(async () => {
    let newBookmarks = [];

    try {
      newBookmarks = await getChatMessages();

      if (newBookmarks?.length) {
        newBookmarks = newBookmarks.filter(bookmark => bookmark.bookmarkActionId);
      }
    } catch (e) {
      handleError(e);
    }

    setBookmarks(newBookmarks);
  }, [handleError]);

  const handleFilter = useCallback(() => {
    if (isFilterOpen) {
      setFilterActive(null);
    }

    setIsFilterOpen(!isFilterOpen);
  }, [isFilterOpen]);

  const handleRemove = useCallback(async bookmarkIndex => {
    try {
      const bookmark = bookmarks[bookmarkIndex];

      if (bookmark.bookmarkActionId) {
        const response = await unbookmarkMessage(bookmark.bookmarkActionId);

        if (response) {
          setBookmarks(prevBookmarks => {
            prevBookmarks.splice(bookmarkIndex, 1);
            return [...prevBookmarks];
          });
        }
      }
    } catch (e) {
      handleError(e);
    }
  }, [bookmarks, handleError]);

  useEffect(() => {
    getBookmarks();
  }, [getBookmarks]);

  return (
    <div id="content">
      <div id="bookmarks">
        {!bookmarks?.length ? (
          <div className="loading">No Bookmarks Created Yet</div>
        ) : (
          <>
            <div id="filter" className={isFilterOpen ? 'open' : ''}>
              <div id="filters">
                <div className={'filter' + (filterActive === 'academic' ? ' active' : '')}><img src={process.env.PUBLIC_URL + '/assets/icons/academic.svg'} alt="Academic" onClick={() => setFilterActive('academic')} /></div>
                <div className={'filter' + (filterActive === 'financial' ? ' active' : '')}><img src={process.env.PUBLIC_URL + '/assets/icons/financial.svg'} alt="Financial" onClick={() => setFilterActive('financial')} /></div>
                <div className={'filter' + (filterActive === 'wellbeing' ? ' active' : '')}><img src={process.env.PUBLIC_URL + '/assets/icons/wellbeing.svg'} alt="Wellbeing" onClick={() => setFilterActive('wellbeing')} /></div>
                <div className={'filter' + (filterActive === 'career' ? ' active' : '')}><img src={process.env.PUBLIC_URL + '/assets/icons/career.svg'} alt="Career" onClick={() => setFilterActive('career')} /></div>
              </div>
              <img src={process.env.PUBLIC_URL + '/assets/icons/filter.svg'} alt="Filter" onClick={handleFilter} />
            </div>
            <div className="scrollable chat">
              {bookmarks && bookmarks.map((bookmark, i) => (
                <div key={i} className="bookmark">
                  <img className="delete" src={process.env.PUBLIC_URL + '/assets/icons/bookmark.svg'} alt="Bookmark" onClick={() => handleRemove(i)} />
                  <MarkdownPreview source={bookmark.response} components={{ a: ({ children, href, ...markdownProps }) => (
                    <a href={href} target="_blank" rel="noopener noreferrer" {...markdownProps}>{children}</a>
                  )}} />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Navigation handleFeedback={handleFeedback} />
    </div>
  );
}

export default withAuthenticationRequired(Bookmarks);